import { styled } from "../../../../../../styles";

export const SubtitleConatiner = styled("div", {
  display: "flex",
  alignItems: "center",
});
